import baseAPI from './baseAPI';

export interface UnifiedScheduleEvent {
  id: number;
  scheduleId: string;
  date: string;
  startTime: string;
  endTime: string;
  scheduleType: 'regular' | 'rescheduled' | 'cancelled' | 'makeup' | 'oneday_class' | 'personal' | 'meeting' | 'break';
  title: string;
  description?: string;
  studentName?: string;
  studentContact?: string;
  userId?: number;
  teacherId: number;
  status: 'active' | 'cancelled' | 'completed' | 'expired';
  source: 'regular_lesson' | 'modification_request' | 'teacher_manual' | 'oneday_class' | 'migration';
  relatedRequestId?: number;
  relatedId?: string;
}

export interface UnifiedCalendarParams {
  startDate: string;
  endDate: string;
  teacherId?: number;
  userId?: number;
  scheduleType?: string[];
  includeRegular?: boolean;
  includeModifications?: boolean;
}

export interface BusyTime {
  date: string;
  startTime: string;
  endTime: string;
  reason: string;
}

export interface WeeklySummary {
  weekStart: string;
  weekEnd: string;
  totalLessons: number;
  regularLessons: number;
  oneDayClasses: number;
  personalSchedules: number;
  cancelledLessons: number;
  rescheduledLessons: number;
}

export interface ScheduleCreateRequest {
  title: string;
  description?: string;
  scheduleDate: string;
  startTime: string | null;   // 종일이면 null
  endTime: string | null;     // 종일이면 null
  isAllDay?: boolean;
  scheduleType?: 'regular' | 'regular_lesson' | 'oneday_class' | 'personal' | 'meeting' | 'break' | 'rescheduled';
  relatedId?: string;
  userId?: number;
  studentName?: string;
  studentContact?: string;
  isRecurring?: boolean;
  recurringPattern?: 'daily' | 'weekly' | 'monthly';
  recurringUntil?: string;
  teacherId?: number;
}

// 통합 캘린더 조회
const getUnifiedCalendar = (params: UnifiedCalendarParams) => {
  return baseAPI.get<{ success: boolean; data: { events: UnifiedScheduleEvent[] } }>('/calendar/unified', { params });
};

// 바쁜 시간대 조회
const getBusyTimes = (params: { startDate: string; endDate: string; teacherId?: number }) => {
  return baseAPI.get<{ success: boolean; data: { busyTimes: BusyTime[] } }>('/calendar/busy-times', { params });
};

// 주간 요약 조회
const getWeeklySummary = (params: { weekStart: string; teacherId?: number }) => {
  return baseAPI.get<{ success: boolean; data: WeeklySummary }>('/calendar/weekly-summary', { params });
};

// 개인 일정 생성
const createSchedule = (data: ScheduleCreateRequest) => {
  return baseAPI.post('/calendar/schedule', data);
};

// 특정 일정 조회
const getScheduleById = (scheduleId: string) => {
  return baseAPI.get(`/calendar/schedule/${scheduleId}`);
};

// 일정 수정
const updateSchedule = (scheduleId: string, data: Partial<ScheduleCreateRequest>) => {
  return baseAPI.patch(`/calendar/schedule/${scheduleId}`, data);
};

// 일정 삭제
const deleteSchedule = (scheduleId: string) => {
  return baseAPI.delete(`/calendar/schedule/${scheduleId}`);
};

export const calendarAPI = {
  getUnifiedCalendar,
  getBusyTimes,
  getWeeklySummary,
  createSchedule,
  getScheduleById,
  updateSchedule,
  deleteSchedule
};
